import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";
import { Reveal } from "@/components/Motion";
import { PricingTeaser } from "@/components/pricing/PricingTeaser";

function CountUp({ to = 100 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });
  const reduce = useReducedMotion();
  const [n, setN] = useState(reduce ? to : 0);
  useEffect(() => {
    if (!inView || reduce) { return; }
    const c = animate(0, to, { duration: 1.8, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => c.stop();
  }, [inView, reduce, to]);
  return <span ref={ref} data-testid="hundred-count">{n}%</span>;
}

export function HundredPercent() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 pt-24 lg:pt-36" data-testid="hundred-section">
      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="font-heading font-extrabold text-teal tracking-tighter leading-[0.85] text-[7rem] sm:text-[10rem] lg:text-[13rem]"><CountUp /></div>
          <h2 className="font-heading font-extrabold text-navy tracking-tighter text-3xl sm:text-5xl mt-4">Your sale. All yours.</h2>
          <p className="text-slatev mt-4 max-w-md">No commission on the sale, ever. Private sellers list free for their first 3 months. Dealers pay one flat monthly price per dealership, with unlimited cars.</p>
        </Reveal>
        <PricingTeaser />
      </div>
    </section>
  );
}
